import { Component ,Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  user = JSON.parse(localStorage.getItem('user'));
  userName = this.user?.user_name;
  role = Number(this.user?.role);

  @Input() alertCount;
  constructor(private _auth:AuthService){ }
  

  onLogout() {
    this._auth.logOut()
  }
}
